export const nswQuotesData = [
  {
    "name": "Annandale",
    "value": 1,
    "lat": -33.881224,
    "lng": 151.1709976
  },
  {
    "name": "Auburn",
    "value": 1,
    "lat": -33.8545702,
    "lng": 151.0255673
  },
  {
    "name": "Austral",
    "value": 3,
    "lat": -31.8759835,
    "lng": 147.2869493
  },
  {
    "name": "Bankstown",
    "value": 6,
    "lat": -33.9171897,
    "lng": 151.0335881
  },
  {
    "name": "Barangaroo",
    "value": 1,
    "lat": -33.8614084,
    "lng": 151.2016877
  },
  {
    "name": "Bella Vista",
    "value": 1,
    "lat": -33.7416936,
    "lng": 150.9547183
  },
  {
    "name": "Blacktown",
    "value": 1,
    "lat": -33.7739882,
    "lng": 150.9036186
  },
  {
    "name": "Bondi Junction",
    "value": 1,
    "lat": -33.8912429,
    "lng": 151.248455
  },
  {
    "name": "Botany",
    "value": 2,
    "lat": -33.9815082,
    "lng": 151.17961691669925
  },
  {
    "name": "Box Hill",
    "value": 1,
    "lat": -33.6425,
    "lng": 150.8988889
  },
  {
    "name": "Bungendore",
    "value": 3,
    "lat": -35.2547375,
    "lng": 149.4387166
  },
  {
    "name": "Calderwood",
    "value": 1,
    "lat": -34.5566667,
    "lng": 150.7427778
  },
  {
    "name": "Campsie",
    "value": 1,
    "lat": -33.9143894,
    "lng": 151.1032133
  },
  {
    "name": "Canberra",
    "value": 1,
    "lat": -35.314555850000005,
    "lng": 149.13322115
  },
  {
    "name": "Canterbury",
    "value": 1,
    "lat": -33.92389765,
    "lng": 151.06568021163108
  },
  {
    "name": "Captains Flat",
    "value": 4,
    "lat": -35.5891237,
    "lng": 149.4475597
  },
  {
    "name": "Castle Hill",
    "value": 1,
    "lat": -33.7317524,
    "lng": 151.0069279
  },
  {
    "name": "Cecil Hills",
    "value": 1,
    "lat": -33.89,
    "lng": 150.8511111
  },
  {
    "name": "Cessnock",
    "value": 8,
    "lat": -32.8316667,
    "lng": 151.3511111
  },
  {
    "name": "Cherrybrook",
    "value": 1,
    "lat": -33.72024655,
    "lng": 151.0380762552974
  },
  {
    "name": "Chullora",
    "value": 1,
    "lat": -33.8925,
    "lng": 151.0477778
  },
  {
    "name": "Clarendon",
    "value": 1,
    "lat": -33.6105511,
    "lng": 150.7888909
  },
  {
    "name": "Cobbitty",
    "value": 1,
    "lat": -34.0104185,
    "lng": 150.6922716
  },
  {
    "name": "Corrimal",
    "value": 5,
    "lat": -34.3757279,
    "lng": 150.9048557
  },
  {
    "name": "Cranebrook",
    "value": 4,
    "lat": -33.7048583,
    "lng": 150.70641
  },
  {
    "name": "Cronulla",
    "value": 3,
    "lat": -34.055084050000005,
    "lng": 151.1550223705499
  },
  {
    "name": "Doonside",
    "value": 3,
    "lat": -33.7549501,
    "lng": 150.8685985
  },
  {
    "name": "East Lismore",
    "value": 1,
    "lat": -28.8216638,
    "lng": 153.2884783
  },
  {
    "name": "Eastern Creek",
    "value": 2,
    "lat": -33.8059423,
    "lng": 150.849956
  },
  {
    "name": "Edmondson Park",
    "value": 1,
    "lat": -33.9692716,
    "lng": 150.858626
  },
  {
    "name": "Emerton",
    "value": 2,
    "lat": -33.7477024,
    "lng": 150.8043608
  },
  {
    "name": "Eveleigh",
    "value": 1,
    "lat": -33.895,
    "lng": 151.1913889
  },
  {
    "name": "Fairfield East",
    "value": 3,
    "lat": -33.8747423,
    "lng": 150.9721298
  },
  {
    "name": "Gables",
    "value": 2,
    "lat": -33.6303326,
    "lng": 150.9031329
  },
  {
    "name": "Glenwood",
    "value": 1,
    "lat": -33.7331483,
    "lng": 150.928232
  },
  {
    "name": "Greenacres",
    "value": 1,
    "lat": -33.3618612,
    "lng": 151.417378
  },
  {
    "name": "Greenwich",
    "value": 5,
    "lat": -33.8300104,
    "lng": 151.1855621
  },
  {
    "name": "Greystanes",
    "value": 2,
    "lat": -33.8127801,
    "lng": 150.9402976720001
  },
  {
    "name": "Haymarket",
    "value": 1,
    "lat": -33.8814408,
    "lng": 151.2044524
  },
  {
    "name": "Horningsea Park",
    "value": 1,
    "lat": -33.9460804,
    "lng": 150.8432271
  },
  {
    "name": "Horsely Park",
    "value": 2,
    "lat": -31.8759835,
    "lng": 147.2869493
  },
  {
    "name": "Horsley Park",
    "value": 4,
    "lat": -33.8387723,
    "lng": 150.8484629
  },
  {
    "name": "Jilliby",
    "value": 1,
    "lat": -33.2483333,
    "lng": 151.3844444
  },
  {
    "name": "Kemps Creek",
    "value": 8,
    "lat": -33.8813335,
    "lng": 150.7837238
  },
  {
    "name": "Kensington",
    "value": 1,
    "lat": -33.91701725,
    "lng": 151.2251677447594
  },
  {
    "name": "Lakemba",
    "value": 1,
    "lat": -33.9196311,
    "lng": 151.0749236
  },
  {
    "name": "Landsdowne",
    "value": 1,
    "lat": -33.8983595,
    "lng": 150.9800552769849
  },
  {
    "name": "Lansvale",
    "value": 2,
    "lat": -33.9003985,
    "lng": 150.9510782
  },
  {
    "name": "Lennox Head",
    "value": 2,
    "lat": -28.7910334,
    "lng": 153.5878047
  },
  {
    "name": "Leppington",
    "value": 3,
    "lat": -33.9543857,
    "lng": 150.80806378606871
  },
  {
    "name": "Liverpool",
    "value": 1,
    "lat": -33.9198252,
    "lng": 150.92566
  },
  {
    "name": "Long Beach",
    "value": 2,
    "lat": -35.7011849,
    "lng": 150.2346688
  },
  {
    "name": "Luddenham",
    "value": 2,
    "lat": -33.8779831,
    "lng": 150.6901151
  },
  {
    "name": "Macquarie Park",
    "value": 4,
    "lat": -33.774197,
    "lng": 151.1127326987788
  },
  {
    "name": "Maroubra",
    "value": 1,
    "lat": -33.9453441,
    "lng": 151.2456824
  },
  {
    "name": "Marsden Park",
    "value": 13,
    "lat": -33.6956552,
    "lng": 150.8147975
  },
  {
    "name": "Medowie",
    "value": 2,
    "lat": -32.7316667,
    "lng": 151.8511111
  },
  {
    "name": "Melrose Park",
    "value": 1,
    "lat": -33.8153435,
    "lng": 151.0733298
  },
  {
    "name": "Mitchell",
    "value": 1,
    "lat": -33.75424614984653,
    "lng": 150.6324169986406
  },
  {
    "name": "Mona Vale",
    "value": 1,
    "lat": -33.6769931,
    "lng": 151.3029577
  },
  {
    "name": "Moore Park",
    "value": 1,
    "lat": -33.8958333,
    "lng": 151.2219444
  },
  {
    "name": "Moorebank",
    "value": 1,
    "lat": -33.9332633,
    "lng": 150.949686
  },
  {
    "name": "Mosman",
    "value": 1,
    "lat": -33.8301355,
    "lng": 151.2447663
  },
  {
    "name": "Newcastle",
    "value": 7,
    "lat": -32.9192953,
    "lng": 151.7795348
  },
  {
    "name": "North Strathfield",
    "value": 1,
    "lat": -33.8590236,
    "lng": 151.0881331
  },
  {
    "name": "North Sydney",
    "value": 1,
    "lat": -33.83431575,
    "lng": 151.20919743582414
  },
  {
    "name": "North Wagga Wagga",
    "value": 2,
    "lat": -35.0940156,
    "lng": 147.3778057
  },
  {
    "name": "Nowra",
    "value": 1,
    "lat": -34.8741198,
    "lng": 150.6004709
  },
  {
    "name": "Oakville",
    "value": 1,
    "lat": -33.6256687,
    "lng": 150.8722092
  },
  {
    "name": "Oran Park",
    "value": 1,
    "lat": -33.9948805,
    "lng": 150.7402568
  },
  {
    "name": "Orchard Hills",
    "value": 1,
    "lat": -33.7816667,
    "lng": 150.7177778
  },
  {
    "name": "Parramatta",
    "value": 2,
    "lat": -33.8139843,
    "lng": 151.002666
  },
  {
    "name": "Pennant Hills",
    "value": 2,
    "lat": -33.7384663,
    "lng": 151.0716639
  },
  {
    "name": "Port Kembla",
    "value": 1,
    "lat": -34.4703383,
    "lng": 150.8953674
  },
  {
    "name": "Prairiewood",
    "value": 2,
    "lat": -33.85956555,
    "lng": 150.9014625468122
  },
  {
    "name": "Prospect",
    "value": 2,
    "lat": -33.8002421,
    "lng": 150.9218377
  },
  {
    "name": "Punchbowl",
    "value": 2,
    "lat": -33.9254126,
    "lng": 151.0557609
  },
  {
    "name": "Pyrmont",
    "value": 1,
    "lat": -33.8692145,
    "lng": 151.1923633
  },
  {
    "name": "Queanbeyan",
    "value": 1,
    "lat": -35.3524518,
    "lng": 149.2337634
  },
  {
    "name": "Richmond",
    "value": 2,
    "lat": -28.8632035,
    "lng": 153.0823096
  },
  {
    "name": "Riverwood",
    "value": 1,
    "lat": -33.9472222,
    "lng": 151.0530556
  },
  {
    "name": "Rose Bay",
    "value": 1,
    "lat": -33.8741644,
    "lng": 151.265471
  },
  {
    "name": "Roseberry",
    "value": 1,
    "lat": -28.4816666,
    "lng": 152.9177777
  },
  {
    "name": "Rosehill",
    "value": 5,
    "lat": -33.8239437,
    "lng": 151.02621193724326
  },
  {
    "name": "Rouse Hill",
    "value": 1,
    "lat": -33.6774941,
    "lng": 150.9160933
  },
  {
    "name": "Schofields",
    "value": 1,
    "lat": -33.6971603,
    "lng": 150.8711915
  },
  {
    "name": "South Granville",
    "value": 1,
    "lat": -33.8345097,
    "lng": 151.0060111
  },
  {
    "name": "South Windsor",
    "value": 2,
    "lat": -33.6055342,
    "lng": 150.821953
  },
  {
    "name": "St Marys",
    "value": 2,
    "lat": -33.7650204,
    "lng": 150.7677778
  },
  {
    "name": "Strathfield",
    "value": 1,
    "lat": -33.8791285,
    "lng": 151.0811758
  },
  {
    "name": "Summer Hill",
    "value": 4,
    "lat": -33.8933952,
    "lng": 151.1368729
  },
  {
    "name": "Sydney",
    "value": 4,
    "lat": -33.8698439,
    "lng": 151.2082848
  },
  {
    "name": "Sydney Olympic Park",
    "value": 1,
    "lat": -33.842903,
    "lng": 151.072535
  },
  {
    "name": "Tamworth",
    "value": 1,
    "lat": -31.0900743,
    "lng": 150.9290159
  },
  {
    "name": "The Ponds",
    "value": 1,
    "lat": -33.7066667,
    "lng": 150.9091667
  },
  {
    "name": "The Rocks",
    "value": 1,
    "lat": -33.859992,
    "lng": 151.2083216
  },
  {
    "name": "Thurgoona",
    "value": 1,
    "lat": -36.0451456,
    "lng": 146.9918988
  },
  {
    "name": "Tighes Hill",
    "value": 1,
    "lat": -32.9045031,
    "lng": 151.7562052
  },
  {
    "name": "Tweed Heads",
    "value": 1,
    "lat": -28.1786639,
    "lng": 153.5369986
  },
  {
    "name": "Villawood",
    "value": 4,
    "lat": -33.8808812,
    "lng": 150.9761642
  },
  {
    "name": "Wagga Wagga",
    "value": 2,
    "lat": -35.115,
    "lng": 147.3677778
  },
  {
    "name": "Wanniassa",
    "value": 1,
    "lat": -31.8759835,
    "lng": 147.2869493
  },
  {
    "name": "Warilla",
    "value": 1,
    "lat": -34.552341,
    "lng": 150.8594438
  },
  {
    "name": "Williamtown",
    "value": 4,
    "lat": -32.7944905,
    "lng": 151.8400425
  },
  {
    "name": "Wollongong",
    "value": 1,
    "lat": -34.4278083,
    "lng": 150.893054
  },
  {
    "name": "Worrigee",
    "value": 6,
    "lat": -34.896044,
    "lng": 150.626943
  },
  {
    "name": "beecroft",
    "value": 1,
    "lat": -33.7497631,
    "lng": 151.0657475
  },
  {
    "name": "south hurstville NSW",
    "value": 1,
    "lat": -33.9777213,
    "lng": 151.1060554
  },
  {
    "name": "wetherill park",
    "value": 4,
    "lat": -33.8483333,
    "lng": 150.9011111
  }
];
